import React from 'react';
import './AboutUsPageNumbersSection.scss';

const AboutUsPageNumbersSection = () => {
  return (
    <section className="numbers-section">
      <div className="numbers-container">
        {/* Main Title */}
        <h2 className="numbers-title">The Numbers Behind The Revolution</h2>
        
        {/* Stats Grid */}
        <div className="stats-grid">
          <div className="stat-block">
            <div className="stat-number">2</div>
            <div className="stat-label">Founders</div>
          </div>
          
          <div className="stat-block">
            <div className="stat-text">DTU</div>
            <div className="stat-label">Alumni</div>
          </div>
          
          <div className="stat-block">
            <div className="stat-number">2024</div>
            <div className="stat-label">Revolution Begins</div>
          </div>
          
          <div className="stat-block">
            <div className="stat-symbol">∞</div>
            <div className="stat-label">Potential Unlocked</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsPageNumbersSection;
